import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useStats } from '../../../lib/ctx/stats'

export const StreakCalendarLegend = () => {
  const { colors } = useTheme()
  const [year, theme] = useStats((s) => [s.year, s.theme])

  const getNoReadingColor = () => {
    return theme.streakCalendar?.legend || colors.uiBlack40
  }

  const details = [
    {
      color: theme.primary,
      label: `Best ${year} streak`,
    },
    {
      color: colors.uiWhite70,
      label: 'Days read',
    },
    {
      color: getNoReadingColor(),
      label: 'No reading',
    },
  ]

  return (
    <FlexBox
      className={css`
        gap: 9%;
      `}
    >
      {details.map((detail, i) => (
        <div key={i}>
          <span
            className={css`
              margin-bottom: 2px;
              display: block;
              width: 16px;
              height: 12px;
              border-radius: 4px;
              background-color: ${detail.color};
            `}
          />
          <Text
            className={css`
              margin-bottom: -2px;
            `}
            type="label"
            sizing="L"
            weight="500"
            color={colors.uiWhite}
          >
            {detail.label}
          </Text>
        </div>
      ))}
    </FlexBox>
  )
}
